// extracted by mini-css-extract-plugin
var _1 = "M5xsY6";
var _2 = "rMqCKa";
var _3 = "ijb3oj";
var _4 = "i_rLZN";
var _5 = "uq0OkJ";
export { _1 as "content", _2 as "dots", _3 as "dotsTyping", _4 as "overlay", _5 as "text" }
